export function textEllipsis(line){
  return (
    `display: block;
    display: -webkit-box;
    -webkit-line-clamp: ${line};
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-word;`
  );
}

export function circle(size){
  return (`
    display: inline-flex;
    width: ${size};
    height: ${size};
    border-radius: 50%;
  `);
}
